import React from "react";
import { Modal, Button } from "@themesberg/react-bootstrap";
import { FormattedMessage } from "react-intl";

export default ({ show, onClick }) => {
  return (
    <Modal as={Modal.Dialog} centered show={show} onHide={onClick} size="lg">
      <Modal.Header>
        <Modal.Title className="h5"><FormattedMessage id="policy" /></Modal.Title>
        <Button variant="close" aria-label="Close" onClick={onClick} />
      </Modal.Header>
      <Modal.Body>
        <p>
          <h6><FormattedMessage id="usePolicy_title1" /></h6>
          <FormattedMessage id="usePolicy_content1" />
        </p>
        <p>
          <h6><FormattedMessage id="usePolicy_title2" /></h6>
          <FormattedMessage id="usePolicy_content2" />
        </p>
        <p>
          <h6><FormattedMessage id="usePolicy_title3" /></h6>
          <FormattedMessage id="usePolicy_content3_1" />
          <br /><FormattedMessage id="usePolicy_content3_2" />
        </p>
        <p>
          <h6><FormattedMessage id="usePolicy_title4" /></h6>
          <FormattedMessage id="usePolicy_content4_1" />
          <br /><FormattedMessage id="usePolicy_content4_2" />
        </p>
        <p>
          <h6><FormattedMessage id="usePolicy_title5" /></h6>
          <FormattedMessage id="usePolicy_content5_1" />
          <br />
          <FormattedMessage id="usePolicy_content5_2" />
          <br />
          <FormattedMessage id="usePolicy_content5_3" />
        </p>
      </Modal.Body>
    </Modal>
  );
};
